(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bodycare-loyalty"] && !Shopify.designMode) return;
  try {
    
(() => {
  // Shopify may evaluate this section bundle more than once during editing.
  // Keep one global lifecycle listener and one set of handlers per section root.
  if (window.BodycareClubSection) {
    window.BodycareClubSection.initAll();
    return;
  }
  const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function setup(root) {
    if (root.__bcCleanup) root.__bcCleanup();
    const controller = new AbortController();
    const { signal } = controller;
    const frameIds = new Set();
    const observers = [];
    const money = value => `${root.dataset.currency || '₹'}${Number(value).toLocaleString('en-IN', { maximumFractionDigits: 2 })}`;
    const pointValue = Math.max(0, Number(root.dataset.pointValue) || 1);
    const pointsLabel = root.dataset.pointsLabel || 'points';
    const format = (template, values) => Object.entries(values).reduce((copy, [key, value]) => copy.replaceAll(`[${key}]`, value), template);
    let announceTimer;
    let progressFrame = 0;
    let countFrame = 0;
    const designMode = root.dataset.designMode === 'true' || Boolean(window.Shopify && window.Shopify.designMode);
    root.dataset.enhanced = '';

    const menu = root.querySelector('.bc-nav');
    const menuButton = root.querySelector('.bc-nav-toggle');
    const closeMenu = () => {
      if (!menu || !menuButton) return;
      menu.dataset.open = 'false';
      menuButton.setAttribute('aria-expanded', 'false');
      menuButton.setAttribute('aria-label', root.dataset.menuOpen || 'Open page menu');
    };
    if (menu && menuButton) {
      menuButton.addEventListener('click', () => {
        const open = menu.dataset.open !== 'true';
        menu.dataset.open = String(open);
        menuButton.setAttribute('aria-expanded', String(open));
        menuButton.setAttribute('aria-label', open ? (root.dataset.menuClose || 'Close page menu') : (root.dataset.menuOpen || 'Open page menu'));
      }, { signal });
      menu.addEventListener('click', event => {
        const link = event.target.closest('a');
        if (!link) return;
        const wasOpen = menu.dataset.open === 'true';
        closeMenu();
        if (wasOpen && link.getAttribute('href')?.startsWith('#')) {
          const target = document.getElementById(link.getAttribute('href').slice(1));
          if (target && root.contains(target)) {
            const heading = target.querySelector('h2') || target;
            heading.setAttribute('tabindex', '-1');
            const focusFrame = requestAnimationFrame(() => {
              frameIds.delete(focusFrame);
              heading.focus({ preventScroll: true });
            });
            frameIds.add(focusFrame);
          }
        }
      }, { signal });
      root.addEventListener('keydown', event => {
        if (event.key === 'Escape' && menu.dataset.open === 'true') {
          closeMenu();
          menuButton.focus();
        }
      }, { signal });
    }

    const tabs = [...root.querySelectorAll('.bc-tier-tabs button[data-rate]')];
    const bill = root.querySelector('.bc-bill');
    const billOutput = root.querySelector('[id$="bill-value"]');
    const pointsOutput = root.querySelector('[id$="points-value"]');
    const redeemOutput = root.querySelector('[id$="redeem-value"]');
    const announcement = root.querySelector('[id$="result-announcement"]');
    tabs.forEach(tab => { tab.disabled = false; });
    if (bill) bill.disabled = false;
    let selected = tabs.find(tab => tab.getAttribute('aria-pressed') === 'true') || tabs[0];
    let displayedPoints = 0;
    const moneyAnimations = new Map();
    function animateMoney(output, target, template, initial = false) {
      if (!output) return;
      const previous = moneyAnimations.get(output) || { value: Number(output.textContent.replace(/[^\d.]/g, '')) || 0, frame: 0 };
      cancelAnimationFrame(previous.frame);
      frameIds.delete(previous.frame);
      const paint = value => { output.textContent = template ? format(template, { value: money(value) }) : money(value); };
      if (initial || reducedMotion() || root.dataset.motion === 'off' || root.dataset.animateNumbers === 'false') {
        previous.value = target;
        previous.frame = 0;
        paint(target);
        moneyAnimations.set(output, previous);
        return;
      }
      const from = previous.value;
      const start = performance.now();
      const tick = now => {
        frameIds.delete(previous.frame);
        const progress = reducedMotion() || root.dataset.motion === 'off' ? 1 : Math.min((now - start) / 460, 1);
        previous.value = from + (target - from) * (1 - Math.pow(1 - progress, 3));
        paint(progress === 1 ? target : Math.round(previous.value));
        if (progress < 1) {
          previous.frame = requestAnimationFrame(tick);
          frameIds.add(previous.frame);
        } else previous.frame = 0;
      };
      previous.frame = requestAnimationFrame(tick);
      frameIds.add(previous.frame);
      moneyAnimations.set(output, previous);
    }
    if (pointsOutput) displayedPoints = Number(pointsOutput.textContent.replace(/[^\d]/g, '')) || 0;
    function animatePoints(target, initial = false) {
      if (!pointsOutput) return;
      cancelAnimationFrame(countFrame);
      if (initial || reducedMotion() || root.dataset.motion === 'off' || root.dataset.animateNumbers === 'false') {
        displayedPoints = target;
        pointsOutput.textContent = `${target.toLocaleString('en-IN')} ${pointsLabel}`;
        return;
      }
      const from = displayedPoints;
      const start = performance.now();
      const duration = 460;
      const tick = now => {
        const progress = Math.min((now - start) / duration, 1);
        const ease = 1 - Math.pow(1 - progress, 3);
        displayedPoints = Math.round(from + (target - from) * ease);
        pointsOutput.textContent = `${displayedPoints.toLocaleString('en-IN')} ${pointsLabel}`;
        if (progress < 1) countFrame = requestAnimationFrame(tick);
      };
      countFrame = requestAnimationFrame(tick);
    }
    function updateCalculator(initial = false, announce = false) {
      if (!bill || !selected) return;
      const amount = Number(bill.value);
      const rate = Number(selected.dataset.rate);
      const points = Math.round(amount * rate / 100);
      animateMoney(billOutput, amount, null, initial);
      const value = money(points * pointValue);
      animateMoney(redeemOutput, points * pointValue, root.dataset.redeemTemplate || 'Worth [value] to redeem', initial);
      bill.style.setProperty('--bc-progress', `${((amount - Number(bill.min)) / (Number(bill.max) - Number(bill.min))) * 100}%`);
      animatePoints(points, initial);
      if (announce && announcement) {
        clearTimeout(announceTimer);
        announceTimer = setTimeout(() => {
          announcement.textContent = format(root.dataset.announcementTemplate || '[tier]: [points] estimated points, worth [value], on a [bill] eligible bill.', { tier: selected.textContent.trim(), points, value, bill: money(amount) });
        }, 180);
      }
    }
    tabs.forEach(tab => tab.addEventListener('click', () => {
      selected = tab;
      tabs.forEach(item => item.setAttribute('aria-pressed', String(item === tab)));
      updateCalculator(false, true);
    }, { signal }));
    if (bill) {
      bill.addEventListener('input', () => updateCalculator(false, false), { signal });
      bill.addEventListener('change', () => updateCalculator(false, true), { signal });
      updateCalculator(true, false);
    }
    if ('IntersectionObserver' in window && root.dataset.animateNumbers !== 'false' && !reducedMotion() && root.dataset.motion !== 'off' && !designMode) {
      const calculator = root.querySelector('.bc-calc');
      const calculatorObserver = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        displayedPoints = 0;
        moneyAnimations.forEach(state => { state.value = 0; });
        updateCalculator(false, false);
        calculatorObserver.disconnect();
      }, { threshold: .2 });
      if (calculator) calculatorObserver.observe(calculator);
      observers.push(calculatorObserver);
    }

    // Keep original numeric text for assistive technology; animate visual digits only.
    // Avoid calculator outputs, whose values are updated by their own live handlers.
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const textNodes = [];
    while (walker.nextNode()) {
      const node = walker.currentNode;
      if (!/\d/.test(node.textContent) || node.parentElement.closest('script,style,svg,noscript,.bc-counter,.bc-sr-only,[aria-live],[id$="bill-value"],[id$="points-value"],[id$="redeem-value"]')) continue;
      textNodes.push(node);
    }
    textNodes.forEach(node => {
      const matches = [...node.textContent.matchAll(/\d{1,3}(?:,\d{3})+(?:\.\d+)?|\d+(?:\.\d+)?/g)];
      if (!matches.length) return;
      const fragment = document.createDocumentFragment();
      let offset = 0;
      matches.forEach(match => {
        fragment.append(document.createTextNode(node.textContent.slice(offset, match.index)));
        const counter = document.createElement('span');
        counter.className = 'bc-counter';
        counter.dataset.counterFinal = match[0];
        const visual = document.createElement('span');
        visual.className = 'bc-counter-visual';
        visual.setAttribute('aria-hidden', 'true');
        visual.textContent = match[0];
        const accessible = document.createElement('span');
        accessible.className = 'bc-sr-only';
        accessible.textContent = match[0];
        counter.append(visual, accessible);
        fragment.append(counter);
        offset = match.index + match[0].length;
      });
      fragment.append(document.createTextNode(node.textContent.slice(offset)));
      node.replaceWith(fragment);
    });
    const staticCounters = [...root.querySelectorAll('.bc-counter')];
    function countVisibleNumber(counter) {
      if (counter.dataset.counted) return;
      counter.dataset.counted = 'true';
      const visual = counter.querySelector('.bc-counter-visual');
      const final = counter.dataset.counterFinal;
      const target = Number(final.replaceAll(',', ''));
      if (!target) return;
      const decimals = final.includes('.') ? final.split('.')[1].length : 0;
      const padded = /^0\d+$/.test(final);
      const start = performance.now();
      let frame = 0;
      visual.style.minWidth = `${visual.getBoundingClientRect().width}px`;
      const tick = now => {
        frameIds.delete(frame);
        const progress = reducedMotion() || root.dataset.motion === 'off' ? 1 : Math.min((now - start) / 850, 1);
        const value = target * (1 - Math.pow(1 - progress, 3));
        let text = decimals ? value.toFixed(decimals) : String(Math.round(value));
        if (padded) text = text.padStart(final.length, '0');
        else if (final.includes(',')) text = Number(text).toLocaleString('en-IN', { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
        visual.textContent = progress === 1 ? final : text;
        if (progress < 1) {
          frame = requestAnimationFrame(tick);
          frameIds.add(frame);
        } else visual.style.minWidth = '';
      };
      frame = requestAnimationFrame(tick);
      frameIds.add(frame);
    }
    if ('IntersectionObserver' in window && root.dataset.animateNumbers !== 'false' && !reducedMotion() && root.dataset.motion !== 'off' && !designMode) {
      const counterObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting && entry.boundingClientRect.height > 0) {
            countVisibleNumber(entry.target);
            counterObserver.unobserve(entry.target);
          }
        });
      }, { threshold: .15 });
      staticCounters.forEach(counter => counterObserver.observe(counter));
      observers.push(counterObserver);
    }

    const faqButtons = [...root.querySelectorAll('.bc-faq-question')];
    function setFaq(button, open) {
      button.setAttribute('aria-expanded', String(open));
      const panel = document.getElementById(button.getAttribute('aria-controls'));
      if (panel && root.contains(panel)) panel.inert = !open;
      const sign = button.querySelector('.bc-faq-sign');
      if (sign) sign.textContent = open ? '−' : '+';
    }
    faqButtons.forEach((button, index) => setFaq(button, index === 0));
    faqButtons.forEach(button => button.addEventListener('click', () => {
      const nextOpen = button.getAttribute('aria-expanded') !== 'true';
      faqButtons.forEach(item => setFaq(item, item === button && nextOpen));
    }, { signal }));
    root.addEventListener('shopify:block:select', event => {
      const selectedButton = event.target.closest('.bc-faq-item')?.querySelector('.bc-faq-question');
      if (selectedButton) faqButtons.forEach(button => setFaq(button, button === selectedButton));
    }, { signal });

    const navLinks = [...root.querySelectorAll('[data-section-nav]')].filter(link => link.getAttribute('href')?.startsWith('#'));
    const sections = navLinks.map(link => document.getElementById(link.getAttribute('href').slice(1))).filter(section => section && root.contains(section));
    if ('IntersectionObserver' in window && sections.length) {
      const navObserver = new IntersectionObserver(entries => {
        const visible = entries.filter(entry => entry.isIntersecting).sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
        if (!visible) return;
        navLinks.forEach(link => {
          if (link.getAttribute('href') === `#${visible.target.id}`) link.setAttribute('aria-current', 'location');
          else link.removeAttribute('aria-current');
        });
      }, { rootMargin: '-80px 0px -55% 0px', threshold: [0, .2, .5] });
      sections.forEach(section => navObserver.observe(section));
      observers.push(navObserver);
    }
    function updateProgress() {
      progressFrame = 0;
      const total = Math.max(document.documentElement.scrollHeight - window.innerHeight, 1);
      root.style.setProperty('--bc-scroll', `${Math.min(100, Math.max(0, window.scrollY / total * 100))}%`);
    }
    window.addEventListener('scroll', () => {
      if (!progressFrame) progressFrame = requestAnimationFrame(updateProgress);
    }, { passive: true, signal });
    updateProgress();

    if ('IntersectionObserver' in window && !reducedMotion() && root.dataset.motion !== 'off' && !designMode) {
      const revealItems = [...root.querySelectorAll('.bc-reveal')];
      const revealObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('bc-visible');
          revealObserver.unobserve(entry.target);
        });
      }, { threshold: .08, rootMargin: '0px 0px 35px 0px' });
      revealItems.forEach(item => revealObserver.observe(item));
      observers.push(revealObserver);
      root.classList.add('bc-motion-ready');
    }

    // Pause decorative loops outside the viewport and when this tab is hidden.
    // Calculator and keyboard interactions stay available at all times.
    const syncVisibility = () => {
      root.dataset.motionPaused = String(document.hidden);
    };
    document.addEventListener('visibilitychange', syncVisibility, { signal });
    syncVisibility();
    if ('IntersectionObserver' in window && !designMode) {
      const motionObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          entry.target.dataset.motionPaused = String(!entry.isIntersecting);
        });
      }, { rootMargin: '80px' });
      root.querySelectorAll('.bc-stage,.bc-tier,.bc-calc,.bc-step').forEach(item => motionObserver.observe(item));
      observers.push(motionObserver);
    }

    if (window.matchMedia('(hover:hover) and (pointer:fine)').matches && !reducedMotion() && root.dataset.motion === 'full') {
      const stage = root.querySelector('.bc-stage');
      if (stage) {
        let stageFrame = 0;
        stage.addEventListener('pointermove', event => {
          if (reducedMotion()) return;
          if (stageFrame) return;
          const rect = stage.getBoundingClientRect();
          const x = (event.clientX - rect.left) / rect.width - .5;
          const y = (event.clientY - rect.top) / rect.height - .5;
          stageFrame = requestAnimationFrame(() => {
            frameIds.delete(stageFrame);
            stage.style.setProperty('--bc-px', `${x * 10}px`);
            stage.style.setProperty('--bc-py', `${y * 7}px`);
            stageFrame = 0;
          });
          frameIds.add(stageFrame);
        }, { signal });
        stage.addEventListener('pointerleave', () => {
          stage.style.setProperty('--bc-px', '0px');
          stage.style.setProperty('--bc-py', '0px');
        }, { signal });
      }
      root.querySelectorAll('[data-tilt-card]').forEach(card => {
        let cardFrame = 0;
        card.addEventListener('pointermove', event => {
          if (reducedMotion()) return;
          if (cardFrame) return;
          const rect = card.getBoundingClientRect();
          const x = (event.clientX - rect.left) / rect.width;
          const y = (event.clientY - rect.top) / rect.height;
          cardFrame = requestAnimationFrame(() => {
            frameIds.delete(cardFrame);
            card.style.setProperty('--bc-tilt-x', `${(y - .5) * -5}deg`);
            card.style.setProperty('--bc-tilt-y', `${(x - .5) * 5}deg`);
            card.style.setProperty('--bc-light-x', `${x * 100}%`);
            card.style.setProperty('--bc-light-y', `${y * 100}%`);
            cardFrame = 0;
          });
          frameIds.add(cardFrame);
        }, { signal });
        card.addEventListener('pointerleave', () => {
          card.style.setProperty('--bc-tilt-x', '0deg');
          card.style.setProperty('--bc-tilt-y', '0deg');
        }, { signal });
      });
    }

    root.__bcCleanup = () => {
      controller.abort();
      observers.forEach(observer => observer.disconnect());
      frameIds.forEach(id => cancelAnimationFrame(id));
      cancelAnimationFrame(progressFrame);
      cancelAnimationFrame(countFrame);
      clearTimeout(announceTimer);
      staticCounters.forEach(counter => {
        const visual = counter.querySelector('.bc-counter-visual');
        visual.textContent = counter.dataset.counterFinal;
        visual.style.minWidth = '';
      });
      faqButtons.forEach(button => {
        const panel = document.getElementById(button.getAttribute('aria-controls'));
        if (panel && root.contains(panel)) panel.inert = false;
      });
      root.classList.remove('bc-motion-ready');
      delete root.dataset.enhanced;
      delete root.__bcCleanup;
    };
  }

  const rootsWithin = target => {
    const roots = [];
    if (target.matches?.('[data-bc-loyalty-root]')) roots.push(target);
    roots.push(...target.querySelectorAll?.('[data-bc-loyalty-root]') || []);
    return roots;
  };
  const initAll = () => document.querySelectorAll('[data-bc-loyalty-root]').forEach(setup);
  window.BodycareClubSection = { initAll };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll, { once: true });
  else initAll();
  document.addEventListener('shopify:section:load', event => rootsWithin(event.target).forEach(setup));
  document.addEventListener('shopify:section:unload', event => rootsWithin(event.target).forEach(root => root.__bcCleanup?.()));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (() => {
    const rowSelector = '.cc-main-product .product-options .option-selector[data-selector-type="listed"] .option-selector__btns';

    if (window.bcPdpOptionScroller) {
      window.bcPdpOptionScroller.init(document);
      return;
    }

    const initializedRows = new WeakSet();
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    const updateRow = (row) => {
      const maxScroll = Math.max(0, row.scrollWidth - row.clientWidth);
      const scrollPosition = Math.min(maxScroll, Math.abs(row.scrollLeft));
      const hasOverflow = maxScroll > 2;
      const wrapper = row.closest('.bc-option-scroll');
      const previousButton = wrapper?.querySelector('[data-bc-option-scroll="-1"]');
      const nextButton = wrapper?.querySelector('[data-bc-option-scroll="1"]');
      const atStart = !hasOverflow || scrollPosition <= 2;
      const atEnd = !hasOverflow || maxScroll - scrollPosition <= 2;

      row.classList.toggle('bc-option-scroll--overflow', hasOverflow);
      row.classList.toggle('bc-option-scroll--start', hasOverflow && atStart);
      row.classList.toggle('bc-option-scroll--end', hasOverflow && atEnd);
      wrapper?.classList.toggle('bc-option-scroll--overflow', hasOverflow);

      if (previousButton) {
        previousButton.hidden = !hasOverflow;
        previousButton.disabled = atStart;
      }
      if (nextButton) {
        nextButton.hidden = !hasOverflow;
        nextButton.disabled = atEnd;
      }
    };

    const centerLabel = (row, label, smooth = false) => {
      if (!row || !label || row.scrollWidth <= row.clientWidth + 2) return;

      const rowRect = row.getBoundingClientRect();
      const labelRect = label.getBoundingClientRect();
      const target = row.scrollLeft + labelRect.left - rowRect.left - (row.clientWidth - labelRect.width) / 2;

      row.scrollTo({
        left: target,
        behavior: smooth && !reducedMotion.matches ? 'smooth' : 'auto'
      });
    };

    const centerSelected = (row, smooth = false) => {
      const selected = row.querySelector('.opt-btn:checked + .opt-label');
      centerLabel(row, selected, smooth);
    };

    const initializeRow = (row) => {
      if (!initializedRows.has(row)) {
        initializedRows.add(row);
        const wrapper = row.closest('.bc-option-scroll');
        const isRtl = getComputedStyle(row).direction === 'rtl';
        row.classList.toggle('bc-option-scroll--rtl', isRtl);
        wrapper?.classList.toggle('bc-option-scroll--rtl', isRtl);
        let scrollFrame = 0;

        row.addEventListener('scroll', () => {
          if (scrollFrame) return;
          scrollFrame = requestAnimationFrame(() => {
            scrollFrame = 0;
            updateRow(row);
          });
        }, { passive: true });

        wrapper?.querySelectorAll('[data-bc-option-scroll]').forEach((button) => {
          button.addEventListener('click', () => {
            const logicalDirection = Number(button.dataset.bcOptionScroll);
            const pageDistance = Math.max(120, row.clientWidth * 0.78);
            row.scrollBy({
              left: logicalDirection * pageDistance * (isRtl ? -1 : 1),
              behavior: reducedMotion.matches ? 'auto' : 'smooth'
            });
          });
        });
      }

      requestAnimationFrame(() => {
        updateRow(row);
        centerSelected(row);
        requestAnimationFrame(() => updateRow(row));
      });
    };

    const init = (root = document) => {
      if (root.matches?.(rowSelector)) initializeRow(root);
      root.querySelectorAll?.(rowSelector).forEach(initializeRow);
    };

    const updateAll = () => {
      document.querySelectorAll(rowSelector).forEach(updateRow);
    };

    window.bcPdpOptionScroller = { init, updateAll };

    const start = () => {
      init(document);

      const observerRoot = document.getElementById('MainContent') || document.body;
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === Node.ELEMENT_NODE) init(node);
          });
        });
      });
      observer.observe(observerRoot, { childList: true, subtree: true });

      let resizeFrame = 0;
      window.addEventListener('resize', () => {
        if (resizeFrame) return;
        resizeFrame = requestAnimationFrame(() => {
          resizeFrame = 0;
          updateAll();
        });
      }, { passive: true });
    };

    document.addEventListener('change', (event) => {
      const input = event.target.closest?.(`${rowSelector} .opt-btn`);
      if (!input) return;
      centerSelected(input.closest('.option-selector__btns'), true);
    }, true);

    document.addEventListener('focusin', (event) => {
      const input = event.target.closest?.(`${rowSelector} .opt-btn`);
      if (!input) return;
      centerLabel(input.closest('.option-selector__btns'), input.nextElementSibling, true);
    });

    document.addEventListener('shopify:section:load', (event) => init(event.target));

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
